import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Modal } from '@common/ui/general';
import {
  setReferralInfoModalState,
} from '~referral/stores/streakReferralModal';
import { useTranslations } from '@common/hooks';

import EndStateModal from './EndStateModal';
import Form from './Form';
import Footer from './Footer';
import Header from './Header';
import ReferralStateModal from './ReferralStateModal';
import withMenteeReferralTranslations
  from '~referral/hoc/withMenteeReferralTranslations';


function NudgePostSharedModal({
  isOpen,
  analytics,
  onClose,
  nudgeType,
  hasUgAccess = false,
  isUgCgrStreakStats = false,
}) {
  const { translations } = useTranslations();
  const dispatch = useDispatch();

  const [endState, isEndState] = useState(false);
  const [formOpen, setFormOpen] = useState(true);

  const referralInfoModalState = useSelector(
    state => state.referral.streakReferralModal.referralInfoModalState,
  );

  const nudgeSharedModalOnClose = () => {
    dispatch(setReferralInfoModalState(true));
    setFormOpen(false);
  };

  const popOverContent = translations?.modalContent;
  const onCloseReferralModal = () => {
    dispatch(setReferralInfoModalState(false));
  };

  return (
    <div className="nudge-wrapper">
      <>
        <Modal
          isOpen={isOpen && formOpen}
          onClose={onClose}
          className="nudge-shared-modal"
          hasCloseButton
          withoutHeader
        >
          <div className="nudge-shared-modal__header-wrapper">
            <Header
              hasUGAccess={hasUgAccess}
              isUgCgrStreakStats={isUgCgrStreakStats}
            />
          </div>
          <Form
            popOverContent={popOverContent}
            analytics={analytics}
            onClose={nudgeSharedModalOnClose}
            nudgeType={nudgeType}
            hasUGAccess={hasUgAccess}
            isUgCgrStreakStats={isUgCgrStreakStats}
          />
          <Footer
            analytics={analytics}
            translations={translations?.modalContent}
            source={nudgeType}
            hasUGAccess={hasUgAccess}
            isUgCgrStreakStats={isUgCgrStreakStats}
          />
        </Modal>
      </>
      <Modal
        isOpen={referralInfoModalState}
        onClose={onCloseReferralModal}
        className="nudge-shared-modal"
        hasCloseButton
        withoutHeader
      >
        <ReferralStateModal
          translations={translations?.modalContent}
          isEndState={isEndState}
          hasUGAccess={hasUgAccess}
        />
      </Modal>
      <EndStateModal
        endState={endState}
        isEndState={isEndState}
        hasUGAccess={hasUgAccess}
      />
    </div>
  );
}

export default withMenteeReferralTranslations(
  '/modules/academy/mentee/referral/post_shared_happy_flow', 'invite-friends',
)(NudgePostSharedModal);
